import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import Popover from '@material-ui/core/Popover';
import TextField from '@material-ui/core/TextField';
import Snackbar from '@material-ui/core/Snackbar';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';

import * as lessonDetailsActions from '../../../actions/lessonDetails';

import CircularProgressGreen from '../../../components/CircularProgressGreen';
import { isTrial } from '../../../helpers';

import messages from '../lessonDetailsMessages';

import s from './VideoNotePopover.scss';
import textFieldStyles from '../../../components/styles/TextField.scss';

@injectIntl
@withStyles(s)
@withStyles(textFieldStyles)
@connect(
  state => ({
    auth: state.auth,
    lesson: state.lessonDetails.lesson,
    videoNotes: state.lessonDetails.videoNotes,
    course: state.courseDetails.course,
    lang: state.intl.locale,
  }),
  dispatch =>
    bindActionCreators(
      {
        getLessonVideoNotes: lessonDetailsActions.getLessonVideoNotes,
      },
      dispatch,
    ),
)
export default class VideoNotePopover extends React.Component {
  static propTypes = {
    isAddVideoNoteOpen: PropTypes.bool.isRequired,
    handleVideoNotePopoverClose: PropTypes.func.isRequired,
    videoNoteTime: PropTypes.number.isRequired,
    videoNoteAnchorEl: PropTypes.node.isRequired,
    videoNotes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    course: PropTypes.shape({
      _id: PropTypes.string.isRequired,
    }).isRequired,
    lesson: PropTypes.shape({
      _id: PropTypes.string.isRequired,
    }).isRequired,
    getLessonVideoNotes: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    auth: PropTypes.shape({}).isRequired,
    lang: PropTypes.string.isRequired,
  };

  static contextTypes = {
    fetch: PropTypes.func,
    whitelabeling: PropTypes.shape({}),
    organizationSlug: PropTypes.string,
  };

  state = {
    isVideoNoteSaving: false,
    showIsVideoNoteAddedSnackBar: false,
    videoNote: {
      isPrivate: true,
    },
  };

  addVideoNote = () => {
    const {
      lesson: { _id: lessonId },
      videoNotes,
      getLessonVideoNotes,
      course: { _id: courseId },
      handleVideoNotePopoverClose,
      videoNoteTime,
    } = this.props;
    const { videoNote } = this.state;

    const max = _.max(_.map(videoNotes, 'order'));
    const order = _.isNumber(max) ? max + 1 : 0;

    this.setState({
      isVideoNoteSaving: true,
    });

    return this.context
      .fetch(`/api/courses/${courseId}/video-notes/${lessonId}`, {
        method: 'PUT',
        body: JSON.stringify([
          ...videoNotes,
          { ...videoNote, order, time: videoNoteTime },
        ]),
      })
      .then(res => {
        if (res.ok) {
          this.setState({
            videoNote: {
              isPrivate: true,
            },
            showIsVideoNoteAddedSnackBar: true,
            isVideoNoteSaving: false,
          });

          handleVideoNotePopoverClose();

          getLessonVideoNotes(courseId, lessonId);
        }
      })
      .catch(error => {
        this.setState({
          isVideoNoteSaving: false,
        });
        console.error(error);
      });
  };

  render() {
    const {
      isAddVideoNoteOpen,
      intl: { formatMessage },
      videoNoteAnchorEl,
      videoNoteTime,
      handleVideoNotePopoverClose,
      auth,
    } = this.props;

    const {
      isVideoNoteSaving,
      videoNote,
      showIsVideoNoteAddedSnackBar,
    } = this.state;

    return (
      <div>
        <Popover
          open={isAddVideoNoteOpen}
          anchorEl={videoNoteAnchorEl}
          anchorReference="anchorEl"
          onClose={handleVideoNotePopoverClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          classes={{ paper: s.videoNotePopover }}
        >
          <div className={s.addNotePopoverContent}>
            <TextField
              rows={5}
              rowsMax={5}
              InputProps={{
                classes: {
                  root: textFieldStyles.textField,
                  input: textFieldStyles.textFieldInput,
                  error: textFieldStyles.textFieldError,
                  focused: textFieldStyles.textFieldFocused,
                  disabled: textFieldStyles.textFieldDisabled,
                },
              }}
              inputProps={{
                maxLength: 150,
                'aria-label': formatMessage(messages.videoCommentAriaLabel),
              }}
              label={formatMessage(messages.leaveCommentLabel, {
                time: moment(1000 * videoNoteTime).format('mm:ss'),
              })}
              InputLabelProps={{
                shrink: true,
              }}
              value={videoNote.text}
              onChange={({ target: { value } }) =>
                this.setState(prevState => ({
                  videoNote: { ...prevState.videoNote, text: value },
                }))
              }
              fullWidth
              multiline
            />

            <div className={classNames(s.flex, s.spaceBetween)}>
              <Tooltip
                title={formatMessage(
                  isTrial(auth)
                    ? messages.optionIsNotAvailableForTrial
                    : messages.privateLabel,
                )}
              >
                <div className={s.privateContainer}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        checked={videoNote.isPrivate}
                        name="isPrivate"
                        disabled={isTrial(auth)}
                        onChange={() =>
                          this.setState({
                            videoNote: {
                              ...videoNote,
                              isPrivate: !videoNote.isPrivate,
                            },
                          })
                        }
                      />
                    }
                    className={s.addNotesCheckBox}
                    label={formatMessage(messages.privateLabel)}
                  />
                </div>
              </Tooltip>
              <div>
                <span
                  className={classNames(
                    s.actionButtonWrapper,
                    s.addNotesSaveBtnWrap,
                  )}
                >
                  <Button
                    data-test-id="Nx4GjYMLIF7TW_pThZTB4"
                    variant="contained"
                    className={s.addNotesSaveBtn}
                    onClick={handleVideoNotePopoverClose}
                  >
                    {_.capitalize(formatMessage(messages.close))}
                  </Button>
                </span>
                <span
                  className={classNames(
                    s.actionButtonWrapper,
                    s.addNotesSaveBtnWrap,
                  )}
                >
                  <Button
                    data-test-id="9gwW0H5KZurHm8bf8Z77G"
                    variant="contained"
                    color="primary"
                    disabled={
                      !videoNote.text ||
                      !videoNote.text.trim() ||
                      isVideoNoteSaving
                    }
                    className={s.addNotesSaveBtn}
                    onClick={this.addVideoNote}
                  >
                    {isVideoNoteSaving ? (
                      <FormattedMessage {...messages.savingLabel} />
                    ) : (
                      <FormattedMessage {...messages.saveLabel} />
                    )}
                    {isVideoNoteSaving && <CircularProgressGreen size={24} />}
                  </Button>
                </span>
              </div>
            </div>
            <FormHelperText className={s.privateCheckboxHint}>
              <FormattedMessage {...messages.privateCheckboxHint} />
            </FormHelperText>
          </div>
        </Popover>
        <Snackbar
          open={showIsVideoNoteAddedSnackBar}
          onClose={() => this.setState({ showIsVideoNoteAddedSnackBar: false })}
          autoHideDuration={1000}
          message={formatMessage(messages.noteSuccessAddMsg)}
        />
      </div>
    );
  }
}
